import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ISettingRepository, SimulationSettingSaveResult } from '@/coreInfrastructureModule/interfaces/ISettingRepository';
import { ApiSimulationSetting } from '@/coreInfrastructureModule/axios/generated/settingManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 推奨発注端数処理設定保存UseCase
 */
export class PutSimulationSettingUseCase {
  private repository: ISettingRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: ISettingRepository) {
    this.repository = repository;
  }

  /**
   * 推奨発注端数処理設定を保存する
   * @param request - 変更する設定値
   */
  public async execute(request: ApiSimulationSetting): Promise<INetworkResult<SimulationSettingSaveResult, IError>> {
    try {
      const result = await this.repository.putSimulationSetting(request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          console.error(result.status.error);
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
      }
    } catch (e) {
      console.error('error', e); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
